export const StepTemplates = [
  'default',
  'tiles',
  'automatic',
  'colors',
  'tinting',
  'image-tiles',
  'packages',
] as const

export type StepTemplate = (typeof StepTemplates)[number]

export type Step = {
  id: number | string
  name: string
  variable: string | null
  template: StepTemplate | null
  itemNextStep: string | number
  customOptions: (string | number)[]
  items: (string | number)[]
}
